import { render, staticRenderFns } from "./edite-bsk-match.vue?vue&type=template&id=20707b78&scoped=true"
import script from "./edite-bsk-match.vue?vue&type=script&lang=js"
export * from "./edite-bsk-match.vue?vue&type=script&lang=js"
import style0 from "./edite-bsk-match.vue?vue&type=style&index=0&id=20707b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20707b78",
  null
  
)

export default component.exports